import { render, staticRenderFns } from "./DubEditorTab.vue?vue&type=template&id=520b2d38&scoped=true&"
import script from "./DubEditorTab.vue?vue&type=script&lang=js&"
export * from "./DubEditorTab.vue?vue&type=script&lang=js&"
import style0 from "./DubEditorTab.vue?vue&type=style&index=0&id=520b2d38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520b2d38",
  null
  
)

export default component.exports